import { RpcClient } from "../../../services/rpc-socket/rpcClient";

export const abortDiagnostic = (token: string) => {
  return RpcClient.call("abortDiagnostic", {
    token,
  }) as Promise<boolean>;
};
export const closeDiagnostic = (token: string) => {
  return RpcClient.call("closeDiagnostic", {
    token,
  }) as Promise<boolean>;
};
